import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { pricePointDrilldownTableParser } from 'parser/pricePointParser';
import { getDrilldownTableData } from 'gqlQueries/pricePoint';
const errorMessage: string = 'Something went wrong!';

const dummyData = [
    {
        label: 'growth_abs',
        'manufacturer-1': 1170,
        'manufacturer-2': 1000,
    },
    {
        label: 'growth_percentage',
        'manufacturer-1': 10,
        'manufacturer-2': 20,
    },
];

function useFetchDrilldownTableData() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const pricePointConfig = getConfig('pricePoint', appConfig);

    const [fetchPricePoint, { data: pricePointData, loading: pricePointDataLoading, error: pricePointDataError }] =
        useLazyQuery(getDrilldownTableData, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getDrilldownTableData } = payload;
            if (getDrilldownTableData && 'data' in getDrilldownTableData) {
                const parsedTableData = pricePointDrilldownTableParser(getDrilldownTableData?.data, pricePointConfig);
                setData({ tableData: parsedTableData });
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchPricePointDrilldownTable: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            // if (commonConfig.offset === variables.variables?.offset) {
            //     setData(null);
            //     rawDataRef.current = [];
            //     setError(null);
            // }
            setLoading(true);
            setData(null);
            setError(null);
            fetchPricePoint(variables);
            //onFetchComplete(variables);
        },
    };
}

export { useFetchDrilldownTableData };
